import React from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'

export const Modal = ({
  children,
  onClose,
}: {
  children: React.ReactNode
  onClose: () => void
}) => {
  return createPortal(<ModalBackdrop onClick={onClose}>{children}</ModalBackdrop>, document.body)
}

export const ModalContent = ({
  children,
  onClick,
  maxWidth,
}: {
  children: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
  maxWidth?: string
}) => {
  return (
    <ModalContentStyled
      onClick={onClick ? onClick : (e) => e.stopPropagation()}
      maxWidth={maxWidth}
    >
      {children}
    </ModalContentStyled>
  )
}

export const ModalContentStyled = styled.div<{ maxWidth?: string }>`
  --padding: 20px;
  min-width: 400px;
  background-color: ${(props) => props.theme.appBackground};
  border-radius: 10px;
  color: ${(props) => props.theme.textColor};
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  max-width: ${(props) => props.maxWidth ?? '100%'};
`

export const ModalHeader = styled.div`
  padding: var(--padding);
`

export const ModalBody = styled.div`
  padding: 0 var(--padding);
  padding-bottom: var(--padding);
  flex: 1;
  overflow-y: auto;
`

export const ModalFooter = styled.div`
  padding: 0 var(--padding);
  padding-bottom: var(--padding);
  display: flex;
  gap: 1rem;
`

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
`
